import React from 'react'

const TopSubmenu = props => {
  return (
    <div className="top-submenu">
      {props.children}
    </div>
  )
}

export default TopSubmenu;

